document.addEventListener("DOMContentLoaded", () => {
  const dialogs = document.querySelectorAll(".host-dialog");
  if (!dialogs.length) return;

  // The card is a fixed-size design (Figma), shown at 60% size and scaled down further if the screen is too small.
  const MAX_SCALE = 0.6;

  // On narrow screens only the front card is shown (full size 650 x 944), otherwise both cards (928 x 1071).
  const fit = (dialog) => {
    const compact = window.innerWidth < 760;
    const width = compact ? 650 : 928;
    const height = compact ? 944 : 1071;
    const scale = Math.min(MAX_SCALE, (window.innerWidth - 24) / width, (window.innerHeight - 24) / height);
    dialog.classList.toggle("is-compact", compact);
    dialog.style.setProperty("--w", width);
    dialog.style.setProperty("--h", height);
    dialog.style.setProperty("--s", scale);
  };

  document.querySelectorAll("[data-host-open]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const dialog = document.getElementById(btn.dataset.hostOpen);
      if (!dialog) return;
      fit(dialog);
      dialog.showModal();
    });
  });

  dialogs.forEach((dialog) => {
    dialog.querySelectorAll("[data-host-close]").forEach((btn) => {
      btn.addEventListener("click", () => dialog.close());
    });
    // Clicking anywhere outside the cards closes the popup
    dialog.addEventListener("click", (event) => {
      if (!event.target.closest(".host-card__front, .host-card__back")) dialog.close();
    });
  });

  window.addEventListener("resize", () => {
    dialogs.forEach((dialog) => {
      if (dialog.open) fit(dialog);
    });
  });
});
